import {useGetPrescribedName, useGetPrescribedNameActivities} from '@/modules/products/trade-names/api'
import {EventLog, PrescribedName} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  prescribedName: PrescribedName
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  prescribedName: PrescribedName
}

const PrescribedNameContext = createContext<State>({} as State)

export function PrescribedNameProvider({children, prescribedName: initial}: Props) {
  const [prescribedName] = useGetPrescribedName(initial.id)
  const [activities] = useGetPrescribedNameActivities(initial.id)

  return (
    <PrescribedNameContext.Provider value={{prescribedName: prescribedName || initial, activities}}>
      {children}
    </PrescribedNameContext.Provider>
  )
}

export function usePrescribedNameContext() {
  return useContext(PrescribedNameContext)
}
